goog.provide("shadow.js.shim.module$src$svg$controls$hand_draw_svg$default");
shadow.js.shim.module$src$svg$controls$hand_draw_svg$default = shadow.js.shim.module$src$svg$controls$hand_draw_svg.default;
